import { motion } from 'framer-motion'
import { useState } from 'react'

const categories = ['全部', '蛋糕', '面包', '甜点', '裱花', '翻糖']

const galleryItems = [
  { id: 1, category: '蛋糕', title: '奶油水果蛋糕', image: 'gallery-1.jpg', description: '新鲜水果与奶油的完美结合' },
  { id: 2, category: '面包', title: '法式可颂', image: 'bread.jpg', description: '层层酥脆的经典法式面包' },
  { id: 3, category: '甜点', title: '马卡龙', image: 'macaron.jpg', description: '色彩缤纷的法式小圆饼' },
  { id: 4, category: '裱花', title: '韩式裱花蛋糕', image: 'gallery-4.jpg', description: '精致的豆沙裱花艺术' },
  { id: 5, category: '翻糖', title: '翻糖婚礼蛋糕', image: 'gallery-5.jpg', description: '定制翻糖蛋糕设计' },
  { id: 6, category: '蛋糕', title: '提拉米苏', image: 'dessert.jpg', description: '经典意大利甜品' },
  { id: 7, category: '面包', title: '欧式全麦面包', image: 'article-3.jpg', description: '健康全麦配方' },
  { id: 8, category: '甜点', title: '蒙布朗', image: 'gallery-2.jpg', description: '法式栗子甜品' },
  { id: 9, category: '蛋糕', title: '巴斯克芝士', image: 'gallery-6.jpg', description: '网红芝士蛋糕' },
  { id: 10, category: '裱花', title: '玫瑰花蛋糕', image: 'cake-decor.jpg', description: '仿真玫瑰裱花' },
  { id: 11, category: '翻糖', title: '卡通人物蛋糕', image: 'gallery-3.jpg', description: '可爱的卡通造型' },
  { id: 12, category: '甜点', title: '闪电泡芙', image: 'article-1.jpg', description: '法式精致小点' },
]

export default function Gallery() {
  const [activeCategory, setActiveCategory] = useState('全部')

  const filteredItems = activeCategory === '全部'
    ? galleryItems
    : galleryItems.filter(item => item.category === activeCategory)

  return (
    <div className="grain-overlay">
      {/* Hero */}
      <section className="relative py-20 bg-gradient-to-br from-cream via-cream to-champagne/10">
        <div className="absolute bottom-10 left-10 w-64 h-64 bg-champagne/20 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <h1 className="font-display text-5xl text-chocolate mb-6">作品展示</h1>
            <p className="text-lg text-chocolate/60 max-w-2xl mx-auto">
              精选学员作品与老师创作，每一款都是用心制作的艺术品
            </p>
          </motion.div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-6 py-2 rounded-full font-medium transition-all ${
                  activeCategory === cat
                    ? 'bg-caramel text-white'
                    : 'bg-cream text-chocolate hover:bg-caramel/20'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Masonry-style Grid */}
          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
            {filteredItems.map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className="break-inside-avoid bg-cream rounded-2xl overflow-hidden shadow-lg card-hover group cursor-pointer"
              >
                <div className="relative aspect-square overflow-hidden">
                  <img src={`/images/${item.image}`} alt={item.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
                  <div className="absolute inset-0 bg-gradient-to-t from-chocolate/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                    <div className="text-white">
                      <h3 className="font-display text-lg">{item.title}</h3>
                      <p className="text-sm text-white/80">{item.description}</p>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-champagne to-caramel">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-3xl text-white mb-4">想学习这些技能吗？</h2>
          <p className="text-white/80 mb-8">
            立即报名课程，下一个作品可能就来自您
          </p>
          <a
            href="/courses"
            className="inline-block px-8 py-4 bg-white text-caramel rounded-lg font-semibold hover:bg-cream transition-colors"
          >
            查看课程
          </a>
        </div>
      </section>
    </div>
  )
}